<template>
  <div id="flags">
    <img
      v-for="(item, index) in flags"
      :key="index"
      class="h-4 w-5 mr-1 cursor-pointer"
      :class="{ 'flag-selected': isSelected(item) }"
      :src="getSrcFlag(item)"
      :alt="item.name"
      @click.stop="updateLocale(item)"
    />
  </div>
</template>

<script>
import { ENUM_LOCALE_LIST } from "@/helpers/locale-helper";
export default {
  data() {
    return {
      flags: ENUM_LOCALE_LIST,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.currentUser;
    },
  },
  methods: {
    isSelected(item) {
        return this.currentUser.locale == item.id;
    },
    getSrcFlag(item) {
      return require(`@/assets/images/flags/${item.flag}`);
    },
    updateLocale(item) {
      this.$i18n.locale = item.locale;
      this.$store.dispatch("auth/updateLocale", item.id);
    },
  },
};
</script>

<style>
</style>